/**
 * When a vehicle is selected in My Garage, collapse grid rows that share the same
 * OEM-style numeric token (7–9 digits) in the product title — typical duplicate
 * listings for the same physical module with different year/engine in the title.
 */
(function () {
  function garageVehicleSelected() {
    try {
      var v = JSON.parse(localStorage.getItem('selected_vehicle') || 'null');
      return !!(v && v.year && v.make && v.model);
    } catch (e) {
      return false;
    }
  }

  function oemKeyFromTitle(text) {
    if (!text) return '';
    var m = text.match(/\b(\d{7,9})\b/g);
    if (!m || !m.length) return '';
    return m[m.length - 1];
  }

  function run() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || container.getAttribute('data-garage-oem-dedupe') !== 'true') return;

    var grid = container.querySelector('ul#product-grid.product-grid');
    if (!grid) return;

    if (!garageVehicleSelected()) {
      grid.querySelectorAll('li.grid__item.js-dedupe-hidden').forEach(function (li) {
        li.classList.remove('js-dedupe-hidden');
        li.removeAttribute('hidden');
        li.style.removeProperty('display');
      });
      return;
    }

    var seen = Object.create(null);
    grid.querySelectorAll(':scope > li.grid__item').forEach(function (li) {
      var link =
        li.querySelector('.card__heading a') ||
        li.querySelector('.card-information a[href*="/products/"]');
      var title = link ? link.textContent : '';
      var oem = oemKeyFromTitle(title);
      var key = oem || title.replace(/\s+/g, ' ').trim().toLowerCase();

      if (!key) return;

      if (seen[key]) {
        li.classList.add('js-dedupe-hidden');
        li.setAttribute('hidden', 'hidden');
        li.style.display = 'none';
      } else {
        seen[key] = true;
        li.classList.remove('js-dedupe-hidden');
        li.removeAttribute('hidden');
        li.style.removeProperty('display');
      }
    });
  }

  window.auto101GarageOemDedupe = run;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('storage', function (e) {
    if (e.key === 'selected_vehicle') run();
  });

  window.addEventListener('auto101:garage-changed', run);
})();
